export default "__VITE_ASSET__dd063901__"